import URL from '@/http/common/url'
import AjaxReq from '@/http/ajaxReq'

export default {
  /**
   * 长链接转短链接接口
   * @param longUrl 长链接
   */
  getShortUrl: async function(longUrl) {
    let res = await AjaxReq({
      url: URL.GET_SHORT_URL,
      method: 'post',
      data: {
        url: longUrl,
      },
    })
    return res.data
  },
  // 微信分享--获取签名
  loadWxShare: async function(pageUrl) {
    let res = await AjaxReq({
      url: URL.LOAD_WX_SHARE,
      method: 'get',
      data: {
        pageUrl: pageUrl,
      },
    })
    return res.data
  },
  // 获取分享海报
  getSharePoster: async function(pageUrl, avatar, nickname, tagName, couponName, goodsImg, goodsName, marketPrice, vipPrice) {
    let res = await AjaxReq({
      url: URL.GET_SHARE_POSTER,
      method: 'post',
      data: {
        pageUrl: pageUrl,
        avatar: avatar,
        nickname: nickname,
        tagName: tagName,
        couponName: couponName,
        goodsImg: goodsImg,
        goodsName: goodsName,
        marketPrice: marketPrice,
        vipPrice: vipPrice,
      },
    })
    return res.data
  },
}
